<template>
  <v-dialog
    :value="value"
    :content-class="dialogContentClass"
    :max-width="maxWidth"
    :persistent="persistent"
    no-click-animation
    @input="$emit('input', $event)">
    <v-card class="system-dialog__card" elevation="0">
      <div v-if="showHeader" class="system-dialog__header">
        <h2 class="system-dialog__title">
          <slot name="title">{{ title }}</slot>
        </h2>
        <button
          v-if="showClose"
          type="button"
          class="system-dialog__close"
          :aria-label="$t('button.cancel')"
          @click="onClose">
          <v-icon size="18">close</v-icon>
        </button>
      </div>

      <div class="system-dialog__body" :class="bodyAlignClass">
        <slot></slot>
      </div>

      <div v-if="showActions" class="system-dialog__actions" :class="actionsAlignClass">
        <slot name="actions" :close="onClose"></slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SystemDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: [String, Number],
      default: 480
    },
    persistent: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    // center | end
    actionsAlign: {
      type: String,
      default: 'center'
    },
    // '' | center
    bodyAlign: {
      type: String,
      default: ''
    },
    // 额外挂到 content-class，便于个别弹窗加修饰
    contentClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogContentClass() {
      return ['system-dialog', this.contentClass].filter(Boolean).join(' ')
    },
    actionsAlignClass() {
      return this.actionsAlign === 'end'
        ? 'system-dialog__actions--end'
        : 'system-dialog__actions--center'
    },
    bodyAlignClass() {
      return this.bodyAlign === 'center' ? 'system-dialog__body--center' : ''
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
      this.$emit('input', false)
    }
  }
}
</script>
